import React, { useEffect, useState } from 'react';
import Terminal from 'terminal-in-react';
import firebase from "firebase/app";
import removeMarkdown from "markdown-to-text";
import  Metadata  from './Metadata';
import { initGA, logPageView } from '../utils/analytics'
import moment from "moment";
const genUsername = require("unique-username-generator");
import descriptions from '../utils/descriptions';

const key =  Math.random().toString(16).slice(2);

const strip = (html) => {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || " ";
}

const showHelp = () => {
    let msg = `COMMANDS LIST: \n\n`;
    Object.keys(descriptions).forEach(command => {
        msg += `${command} - ${descriptions[command]} \n`
    })
    return msg;
}
// console.log(window.location.pathname);

export default function HNTerminal() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());    
    const [ meta, setMeta] = useState({title: "Terminal Reader", description: "The best tech content in a terminal view"});
    const [ loading, setLoading] = useState(false);
    const [ message, setMessage] = useState(window.location.pathname === "/help" ? showHelp() : "");
    const [ stories, setStories] = useState([]);
    const [callsCounter, setCallsCounter] = useState(0);
    const [ securityThreat, setSecurityThreat] = useState(false);
    const initStartTime = moment();
    let topScreen = false;

    useEffect(() => {
        let mounted = true;
        if(mounted){
            if(window.location.pathname !== "/"){
                if(window.location.pathname !== "/help") {
                    getStory(window.location.pathname.replace("/",""));
                }
            } 
            else getStories("hackernoon-top-story", 5);
        }
        window.addEventListener('scroll', handleScroll);

        
        return () => { // This code runs when component is unmounted
            mounted = false;
            window.removeEventListener('scroll', handleScroll);
        }
    }, [window.location.pathname]);

    useEffect(() => {
        if(!loading){
            const e = document.getElementsByClassName("dMFuoo")[0]
            const e1 = document.getElementsByClassName("hdqhPL")[0];
            // console.log(elem)
            if(e) e.style.overflow = "auto"
            if(e1) e1.remove();
        }
    }, [loading])

    const handleScroll= e => {
        if(!topScreen) {
            // console.log("here")
            window.scrollTo(0,0); 
            topScreen = true;
        }
        else {
            // console.log("next")
            window.scrollTo(0,window.pageYOffset)
            // window.
        }
        // console.log("scrolling");
    }

    const getStories = async (tag, limit) => {
        if(!isItHack()){
            setLoading(true);
            const db = firebase.firestore();
            const storiesRef = await db.collection("stories")
            .where("tags", "array-contains", tag)
            .orderBy("publishedAt", "desc")
            .limit(limit).get();
            if(!storiesRef.empty){
                let storiesArr = [];
                let msg = `Heyo Hacker, the current epoch unix timestamp is ${parseInt(new Date().getTime() / 1000, 10)}. Welcome to the HackerNoon terminal reader!\n\n`;

                if(tag === "hackernoon-top-story") msg += `HACKERNOON TOP STORIES TODAY:\n\n`;
                else msg += `STORIES ABOUT: "${tag}"\n\n`;
        
                storiesRef.docs.forEach((doc, i) => {
                    const { title, slug, publishedAt, estimatedTime, mainImage, tldr, profile} = doc.data();
                    // console.log(`${i+1}) ${title} ${estimatedTime ? `(${estimatedTime} min read)` : ''}`);
                    msg += `${i+1}) ${title} ${estimatedTime ? `(${estimatedTime} min read)` : ''} ${i !== storiesRef.docs.length - 1 ? '\n' : '\n\n'}`;
                    let content;
                    if(doc.data()?.parsed) content = strip(doc?.data()?.parsed);
                    else if(doc.data()?.markup) content = strip(doc?.data()?.markup);
                    else content = removeMarkdown(doc.data()?.markdown).replace(/\\/g, " ");

                    storiesArr.push({
                        id: doc.id, 
                        publishedAt,
                        title, 
                        mainImage,
                        slug,
                        url: `https://hackernoon.com/${slug}`,
                        content,
                        ...(profile && {displayName: profile.displayName, handle: profile.handle }),
                        ...(tldr && {tldr}),
                        ...(estimatedTime && {estimatedTime}),
        
                    })
                })
                setStories(storiesArr);
                setMessage(msg);
                setCallsCounter(callsCounter + 1);
            } else {
                setMessage("EMPTY: NO STORIES!")
                // console.log("EMPTY: NO STORIES!")
            }
            setLoading(false);
        } else {
            setMessage("Sorry, you've reached the limit of requests! Please try again later!");
            setSecurityThreat(true);
        }
    }

    function isNumeric(value) {
        return /^-?\d+$/.test(value);
    }
        
    const getStory = async (slug) => {
        if(!isItHack()){
            setLoading(true);
            const db = firebase.firestore();
            const storiesRef = await db.collection("stories")
            .where("slug", "==", slug)
            .limit(1).get();
            if(!storiesRef.empty){
                const data = storiesRef.docs[0].data();
                const { title, profile, publishedAt } = storiesRef.docs[0].data();
                let msg = `Heyo Hacker, the current epoch unix timestamp is ${parseInt(new Date().getTime() / 1000, 10)}. Welcome to the HackerNoon terminal reader!\n\n`;
                setMeta({title: `${title} (terminal reader)`, ...(storiesRef.docs[0].data().excerpt && {description: storiesRef.docs[0].data().excerpt})})
                msg +='-------------------------------------------------------------------------------\n';
                msg += `${title.toUpperCase()}\n`;
                msg += `Published on ${new Date(publishedAt.toDate()).toLocaleDateString()} by ${profile.displayName}\n`;
                msg +='-------------------------------------------------------------------------------\n';
                if(data?.parsed) msg += strip(data?.parsed);
                else if(data?.markup) msg += strip(data?.markup);
                else msg += removeMarkdown(data?.markdown).replace(/\\/g, " ");
                setMessage(msg);
                setCallsCounter(callsCounter + 1);
                initGA();
                logPageView(`/${slug}`);
            } else {
                setMessage("STORY NOT FOUND, CHECK STORY SLUG!")
            }
            setLoading(false);
        }else {
            setMessage("Sorry, you've reached the limit of requests! Please try again later!");
            setSecurityThreat(true);
        }
    }

    const getStoryAudioSrc = async (id) => {
        if(!isItHack()){
            // setLoading(true);
            const db = firebase.firestore();
            const audioDoc = await db.collection("story-audios").doc(id).get();
            if(audioDoc.exists){
                const { audios } = audioDoc.data();
                // setLoading(false);
                return audios[0];
            } 
            // setLoading(false);            
            return;
        }else {
            setMessage("Sorry, you've reached the limit of requests! Please try again later!");
            setSecurityThreat(true);
        }
    }

    //maybe for next time?
    const handlePlayStory = async (index, print) => {
        removeAudio();
        showStory(index, print);

        const storyAudio = await getStoryAudioSrc(stories[index].id);
        if(storyAudio){
            const audio = document.createElement("audio");
            audio.setAttribute("src", storyAudio.url);
            let root = document.getElementById("root");
            root.appendChild(audio);
            audio.play();
            print('-------------------------------------------------------------------------------');
            print(`READ BY ${storyAudio.nickname}`);
            print('-------------------------------------------------------------------------------');
        }else {
            print('-------------------------------------------------------------------------------');
            print(`ATTENTION: THIS STORY DOES NOT YET HAVE AUDIO PRODUCED!`);
            print('-------------------------------------------------------------------------------');
        }
    }

    const removeAudio = () => {
        const audio = document.querySelector("audio");
        if(audio) audio.parentNode.removeChild(audio);
    }

    const showStory = (index, screenPrint) => {
    //     setMachineName()
        if(window.location.pathname === "/") {
            setMeta({
                title: `${stories[index].title} (terminal reader)`,
                ...(stories[index].excerpt && {description: stories[index].excerpt}),
            })
            var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + stories[index].slug;
            window.history.pushState({path:newUrl},'',newUrl);
            initGA();
            logPageView(`/${stories[index].slug}`);
        }
        screenPrint('-------------------------------------------------------------------------------');
        screenPrint(stories[index].title.toUpperCase())
        screenPrint(`Published on ${new Date(stories[index].publishedAt.toDate()).toLocaleDateString()} by ${stories[index].displayName}\n`);
        screenPrint('-------------------------------------------------------------------------------');
        // screenPrint(removeMarkdown(stories[index].content).replace(/\\/g, " ");
        // if(stories[index].type === "markdown") screenPrint(removeMarkdown(stories[index].content).replace(/\\/g, " "))
        screenPrint(strip(stories[index]?.content));
    };

    const showStories = (screenPrint) => {
        if(stories.length > 0) {
            screenPrint('-------------------------------------------------------------------------------');
            screenPrint("Most Recent Stories:");
            stories.forEach((story, i) => {
                screenPrint(`${i+1}) ${story.title} ${story.estimatedTime ? `(${story.estimatedTime} min read)` : ''}`);
            }) 
        } else getStories("hackernoon-top-story", 5);
    };

    const isItHack = () => {
        let reqPerSecond = 3;
        let now = moment();
        let difference = now.diff(initStartTime, 'seconds');
        return ((callsCounter * reqPerSecond) / difference) > reqPerSecond
    }

    const runHack = (data, printing) => {
        printing('running....');
        let i = 0;

        var hackInterval = setInterval(function(){
            if(i < data.length){
                let user = data[i];
                // printing("{");
                printing(`{ \n userUid -> ${user.id},\n handle -> ${user.handle},\n userToken -> ${user.userToken},\n passHash -> ${user.passHash} \n}`)
                i++;
            } else {
                printing(`All done, ${data.length} records produced. Please don't do anything stupid with this data!`)
                clearInterval(hackInterval);
            }
          }, 150)
    }

    function randomString(len, charSet) {
        charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
    }

    const generateHackedData = (ammount) => {
        let data = [];
        let i = 0;
        while(i < ammount){
            data.push({
                id: randomString(25),
                handle: genUsername.generateUsername(),
                userToken: randomString(50),
                passHash: randomString(70)
            })
            i++;
        }
        return data;
    }
 
    if(!localStorage.getItem("machine-name")){
        localStorage.setItem('machine-name', `hn-anonymous-${key}`);
    }

    return (
     
        <div
            style={{
                // height: "100vh",
                // backgroundColor: "#000"
            }}
        >
            <Metadata meta={meta} />
            {!loading ? (
                <Terminal
                    color='green'
                    backgroundColor='black'
                    barColor='black'
                    style={{ fontWeight: "bold", fontSize: "2em"}}
                    startState="maximised"
                    allowTabs={false}
                    showActions={false}
                    commandPassThrough={(cmd) => `-HN-ERROR: "${cmd.join(' ')}" command not found`}
                    commands={{
                        ...(!securityThreat && ({
                            'get-story': (args) => {getStory(args[1].toLowerCase())}, 
                            'top-stories': () => {getStories("hackernoon-top-story", 5)},
                            'tag': (args) => {getStories(args[1].toLowerCase(), 10)},            
                        })),
                        'hack': (args, print) => {
                            if(args.length !== 3) print(`-HN-ERROR: insufficient parameters, try harder!!`);
                            else {
                                if(args[1] === "hn"){
                                    if(isNumeric(args[2])) {
                                        const data = generateHackedData(args[2]);
                                        runHack(data, print)
                                        // data.forEach(user => {
                                        //     print(`user -> ${user.id} exposed with handle ==> ${user.handle}`)
                                        // })
                                    } else print(`-HN-ERROR: could not find '${args[2]}' ammount of records, try harder!!`);
                                } else {
                                    print(`-HN-ERROR: database '${args[1]}' not found, try harder!!`);
                                }
                            }
                        },
                        'reset': () => {
                            window.location = "/";
                        },
                        'tldr': (args, print) => {
                            let index = parseInt(args[1], 10) - 1;
                            if(index <= stories.length - 1) {
                                let tldr = stories[index].tldr;
                                if(tldr) {
                                    print(`TLDR: ${stories[index].title}`)
                                    print('-------------------------------------------------------------------------------');
                                    print(tldr);
                                    print('-------------------------------------------------------------------------------');
                                }
                                else print('Story has no tldr yer!')
                            }else print(`-HN-ERROR: Story index don't exist!`);
                        },
                        'open-img': (args, print) => {
                            let index = parseInt(args[1], 10) - 1;
                            if(index <= stories.length - 1) {
                                let mainImage = stories[index].mainImage;
                                if(mainImage) window.open(mainImage, '_blank');
                                else print('Story has no feature image!')
                            }else print(`-HN-ERROR: Story index don't exist!`);
                        },
                        'writer': (args, print) => {
                            let index = parseInt(args[1], 10) - 1;
                            if(index <= stories.length - 1) {
                                if(stories[index].handle) window.open(`https://hackernoon.com/u/${stories[index].handle}`, '_blank');
                                else print(`-HN-ERROR: Writer not found!`);
                            }
                            else print(`-HN-ERROR: Story index don't exist!`);
                        },
                        'open': (args, print) => {
                            let index = parseInt(args[1], 10) - 1;
                            if(index <= stories.length - 1) window.open(stories[index].url, '_blank');
                            else print(`-HN-ERROR: Story index don't exist!`);
                        },
                        'read': (args, print) => {
                            let index = parseInt(args[1], 10) - 1;
                            if(index <= stories.length - 1) showStory(index, print);
                            else print(`Story index don't exist!`);
                        },
                        'play': (args, print) => {
                            let index = parseInt(args[1], 10) - 1;
                            if(index <= stories.length - 1) handlePlayStory(index, print);
                            else print(`Story index don't exist!`);
                        },
                        'pause': () => removeAudio(),
                        "show-stories": (args, print) => {showStories(print)},
                        'set-machine-name': (args, print, runCommand) => {
                            if(args[1]) {
                                localStorage.setItem('machine-name', args[1]);
                                window.location.reload(true);
                            }else print(`-HN-ERROR: Could not set name, please try again!`);
                        },
                        'machine-specs': (args, print) => {
                            print('-------------------------------------------------------------------------------');
                            print("MACHINE SPECS");
                            print('-------------------------------------------------------------------------------');
                            print(`MACHINE NAME: ${localStorage.getItem("machine-name")}`);
                            print(`SERVER: linux-${key}`);
                            print(`USER-TYPE: anonymous---${key}`);
                            print(`STATUS: up and running`);
                            print(`OWNER: You are you're own boss`);
                            print(`PROCESS RUNNING: ${654561}`);
                            print(`Machine Location: Asia/Shanghai`);
                        },
                        'ad': (args, print) => {
                                getTopNavAd().then(res => {
                                    window.open(res.adWebsite, "_blank")
                                }).catch(e => {
                                    print(`-HN-ERROR: Something went wrong opening ad page!`);
                                }) 
                        },
                        'contact': () => window.open("https://hackernoon.com/contact", "_blank"),
                        'search': (args) => {window.open(`https://hackernoon.com/search?query=${args[1]}`, '_blank')},
                        'privacy': (args) => {window.open(`https://hackernoon.com/privacy`, '_blank')},
                        'terms': (args) => {window.open(`https://hackernoon.com/terms`, '_blank')},
                    }}        
                    descriptions={descriptions}
                    msg={message}

                    promptSymbol={`${localStorage.getItem("machine-name")} >`}
                />
            ) : (
                <div style={{
                    height: '100vh',
                    minWidth: '100%',
                    color: "green",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#000",
                    fontSize: "25px"
                }}>
                    Loading...
                </div>
            )}
        </div>
      
    );
}
